"use client";

import SolarLocationPage from "@/components/locations/solar-location-page";
import { getLocationLandingConfig } from "@/data/location-pages";

const config = getLocationLandingConfig("cadiz");

export default function PlacasSolaresCadizPage({ locale }: { locale: string }) {
  return <SolarLocationPage locale={locale} id="cadiz" config={config} />;
}
